type Order = 'asc' | 'desc'

export const indexBy = <T extends object>(
  list: T[],
  key: (obj: T) => string | number | symbol
) => {
  return list.reduce((acc, item) => ({ ...acc, [key(item)]: item }), {})
}

type Record = { id: string }

export const convertId = <T extends { id: number }>(list: Array<T>) =>
  list.map((item) => ({
    ...item,
    id: item.id.toString(),
  }))

export const sortedKeysBy = <T extends Record, K extends keyof T>(
  obj: { [key: string]: T },
  by: K,
  order: Order = 'asc'
) => {
  const sorted = Object.keys(obj).sort((k1, k2) => {
    if (obj[k1][by] > obj[k2][by]) {
      return 1
    }

    if (obj[k1][by] < obj[k2][by]) {
      return -1
    }

    if (obj[k1].id > obj[k2].id) {
      return 1
    }

    if (obj[k1].id < obj[k2].id) {
      return -1
    }

    return 0
  })

  return order === 'asc' ? sorted : sorted.reverse()
}

export const sortedBy = <T extends Record, K extends keyof T>(
  arr: T[],
  by: K,
  order: Order = 'asc'
) => {
  const sorted = arr.sort((k1, k2) => {
    if (k1[by] > k2[by]) {
      return 1
    }

    if (k1[by] < k2[by]) {
      return -1
    }

    if (k1.id > k2.id) {
      return 1
    }

    if (k1.id < k2.id) {
      return -1
    }

    return 0
  })

  return order === 'asc' ? sorted : sorted.reverse()
}

export const subtract = <T>(l1: T[], l2: T[]) =>
  l1.filter((e: T) => !l2.includes(e))

export const equal = <T>(
  l1: Array<T | undefined>,
  l2: Array<T | undefined>
) => {
  l1 = [...l1]
  l2 = [...l2]
  while (l1.length > 0) {
    const element = l1.shift()
    const num = l2.indexOf(element)
    if (num === -1) {
      return false
    }
    l2.splice(num, 1)
  }
  return l2.length === 0
}
